import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyDistance',
    standalone: true,
})
export class DistancePipe implements PipeTransform {
    transform(distance: number): string {
        const showInMeters = distance < 1000;
        const dist = showInMeters ? Math.round(distance) : (distance / 1000).toFixed(1);
        const unit = showInMeters ? 'm' : 'km';
        return `${dist} ${unit}`;
    }
}
